<template>
  <div>
    <div class="top_header top_sm fixed">
      <div class="m_flex_box flex_vc flex_hc top_normal">
        <p>徐房经纪人用户协议</p>
      </div>
    </div>
    <div class="pad_top"></div>
    <div class="con">
      <h3>《徐房经纪人用户协议》</h3>
      <div class="top_">
        <p>最新更新日期：2023年【2】月【28】日</p>
        <p>生效日期：2020年【2】月【28】日</p>
      </div>
      <p>
        尊敬的徐房经纪人用户：为使用徐房经纪人的服务，您应当阅读并遵守本《徐房经纪人用户协议》（以下简称“本协议”）。本协议是用户与徐房经纪人之间的法律协议，是用户注册账号并使用平台服务或非经注册程序直接使用平台服务时的通用条款。请您务必审慎阅读、充分理解本协议各条款内容，特别是免除或者限制责任的条款、管辖与法律适用条款。如果您不同意本协议的约定，您应立即停止注册程序或停止使用徐房经纪人的服务；如您继续访问和使用徐房经纪人的相关服务，即视为您已确知并完全同意本协议各项约定。-83601286）或者我们设立的个人信息保护专职部门（电子邮件xzsgsgs@126.com）咨询，如您不同意协议中的任何条款，您应立即停止访问或使用徐房经纪人平台。
      </p>

      <p>第一部分 定义</p>
      <p>1、徐房经纪人：指徐房经纪人网站（域名：https://xfjjr.xzhouse.com.cn/erp/）及徐房经纪人客户端等互联网端口。</p>
      <p>2、徐房经纪人平台服务提供者：指徐房经纪人平台的互联网信息及软件技术服务提供者徐州市广盛房地产网络信息有限公司（注册地为徐州市鼓楼区坝子街9号中和大厦四层）。</p>
      <p>
        3、用户，以下亦称为“您”，系指注册或登录徐房经纪人使用徐房经纪人产品或服务的具有完全民事权利能力和行为能力的企业法人、社会团体、自然人或其他社会组织等。按用户是否经过注册程序分为注册用户和非注册用户，注册用户是指通过徐房经纪人平台完成全部注册程序后，使用徐房经纪人平台服务或网站资料的用户。非注册用户是指未进行注册、直接登录徐房经纪人平台或通过其他徐房经纪人平台允许的方式进入平台直接或间接地使用平台服务或网站资料的用户。按用户使用徐房经纪人服务的方式分为：普通用户、经纪人、严选顾问以及管理员用户，其中普通用户是指浏览徐房经纪人提供的信息或者使用徐房经纪人提供的其他服务的主体；经纪人是指通过徐房经纪人进行报备、查看跟进、查看结佣的主体；职业顾问是指通过徐房经纪人进行报备、报备跟进、客源管理、在线获客管理或在徐房经纪人为经纪人用户提供其他服务的主体；管理员用户是指管理经纪人、置业顾问，或者操作报备核心流程的主体。
      </p>
      <p>4、协议方，本协议中的协议方包括徐州市广盛房地产网络信息有限公司以及为徐房经纪人平台提供技术服务、咨询服务的关联方作为一方，统称“徐房经纪人”，您作为另一方。</p>
      <p>第二部分 协议的效力</p>
      <p>1、在您按照注册页面提示填写信息、阅读并同意本协议并完成全部注册程序后或以其他徐房经纪人允许的方式实际使用徐房经纪人平台服务时，您即受本协议的约束。</p>
      <p>
        2、本协议内容包括本协议正文，您在使用徐房经纪人某一特定服务或系统时，该服务可能会另有单独的协议、相关业务规则、公告、帮助、说明、通用条款等（以下统称为“规则”）。所有徐房经纪人已经发布的或将来可能发布的规则均为本协议不可分割的组成部分，与本协议具有同等法律效力。除另行明确声明外，任何徐房经纪人及其关联公司提供的服务（以下称为“徐房经纪人平台服务”）均受本协议约束。您承诺接受并遵守本协议的约定。如果您不同意本协议的约定，您应立即停止注册程序或停止使用徐房经纪人平台服务；如您继续访问和使用徐房经纪人平台服务，即视为您已确知并完全同意本协议各项内容。
        Cookie 和同类技术</p>
      <p>第三部分 注册</p>
      <p>1、您确认，在您完成注册程序时，您应当是具备相应民事行为能力的自然人。</p>
      <p>
        2、在您签署本协议，完成注册程序时，徐房经纪人会向您提供唯一编号的徐房经纪人账户。您应对您的用户账户（手机号码）、验证码的安全以及对通过您的账户实施的行为负责，除非有法律规定或行政司法机关的指令，且征得徐房经纪人的同意，否则您的用户账户不得以任何方式转让、借用、赠与或继承（与账户相关的财产权益除外），您的登录手机号和验证码不得对任何第三方提供或泄露，否则，由此给您（或徐房经纪人、任何第三方）造成的一切损失，概由您自行承担（或者负责赔偿），徐房经纪人不承担任何责任。
      </p>
      <p>
        3、如果发现任何人不当使用您的账户或有任何其他可能危及您的账户安全的情形时，您应当立即与徐房经纪人客服联系并通知徐房经纪人暂停或冻结相关服务。您理解徐房经纪人对您的请求采取行动需要合理时间，徐房经纪人对在采取行动前已经产生的后果（包括但不限于您的任何损失）不承担任何责任。
      </p>
      <p>4、若您或您的账户存在下述情形，徐房经纪人有权限制您的在线沟通工具（包括但不限于IM）使用权限及/或封禁您的徐房经纪人账号。</p>
      <p>1)通过IM等渠道发布任何形式的含低俗内容、涉黄、涉政、涉恐、诈骗、违规贷款等相关违法违规内容的；</p>
      <p>2)通过IM等渠道发布任何形式的广告、微商或进行商品推广、售卖或进行招聘等内容的；/服务范围存在差异，相应地，基本/附加功能及收集使用的个人信息类型、范围等会有所区别，请以具体的产品/服务功能为准；</p>
      <p>3)通过IM等渠道对经纪人、置业顾问进行辱骂、侮辱、威胁、恐吓、人身攻击等；</p>
      <p>4)通过IM等渠道对经纪人、置业顾问进行骚扰、发送与房屋买卖、房屋租售等无关信息，或对经纪人正常工作造成影响的；</p>
      <p>5)通过IM等渠道套取徐房经纪人房产、经纪人等信息，造成房源、经纪人等信息泄漏或其他负面影响的；</p>
      <p>6)存在使用虚拟机、虚拟器、多开设备等情形的；</p>
      <p>7)存在违反其他法律法规、徐房经纪人制定及/或修订的相关规则的</p>
      <p>5、若您或您的徐房经纪人账户违反下述要求，徐房经纪人有权限制注册、登录及/或封禁您的徐房经纪人账号</p>
      <p>1)您须通过正规渠道获取徐房经纪人应用软件，并通过徐房经纪人官方渠道进行注册、登录；</p>
      <p>
        2)不得恶意注册或将徐房经纪人帐号用于非法或不正当用途，不得采取各种技术手段恶意绕开或者违反徐房经纪人平台规则，不得通过修改或伪造软件运行中的指令、数据，增加、删减、变动软件的功能或运行效果，或者将用于上述用途的软件、方法进行运营或向公众传播，无论这些行为是否为商业目的，不得使用插件、外挂等工具恶意侵入徐房经纪人系统或损害徐房经纪人权益；
      </p>
      <p>3)注册及/或登录徐房经纪人平台的用户手机号需是您本人真实在用的状态正常的合法手机号</p>
      <p>4)禁止通过非法手段购买手机号、设备等进行徐房经纪人账号注册&登录；</p>
      <p>5)为保护您的账号安全，徐房经纪人有权对您的账号出现的异常访问进行独立检测判断并采取相应处理措施，异常访问包括但不限于帐号在一定时间内产生行为异常，存在安全隐患或导致资源被过度占用的情形；</p>
      <p>6)您不得违反其他法律法规、徐房经纪人制定及/或修订的相关规则。</p>
      <p>第四部分 徐房经纪人平台服务使用规范</p>
      <p>1、通过徐房经纪人平台，您可以按照徐房经纪人的规则提交项目报备信息。但所上传之信息不得含有如下内容：</p>
      <p>1) 反对宪法所确定的基本原则，煽动抗拒、破坏宪法和法律、行政法规实施的；</p>
      <p>2)煽动危害国家安全、泄露国家秘密、颠覆国家政权，推翻社会主义制度的；</p>
      <p>3)煽动分裂国家、破坏国家统一、损害国家荣誉和民族利益的；</p>
      <p>4)煽动民族仇恨、民族歧视，破坏民族团结的；</p>
      <p>5)捏造或者歪曲事实，散布谣言，扰乱社会秩序的；</p>
      <p>6)进行政治宣传或破坏国家宗教政策、宣扬封建迷信、淫秽、色情、赌博、暴力、凶杀、恐怖、教唆犯罪的；</p>
      <p>7)公然侮辱他人或者捏造事实诽谤他人的，或者进行其他恶意攻击的；</p>
      <p>8)损害国家机关信誉的；</p>
      <p>9)其他违反宪法和法律法规的；</p>
      <p>2、在接受徐房经纪人平台服务的过程中，您不得从事下列行为：</p>
      <p>1)发表、传送、传播、储存侵害他人知识产权、商业秘密权等合法权利的内容，包含病毒、木马、定时炸弹等可能对徐房经纪人系统造成伤害或影响其稳定性的内容制造虚假身份以误导、欺骗他人；</p>
      <p>
        1、为使您使用徐房经纪人平台更便捷或更有乐趣，从而提升您在徐房经纪人的体验，我们的以下附加功能中可能会收集和使用您的个人信息。如果您不提供这些个人信息，您依然可以使用徐房经纪人的产品或服务中的核心功能，但您可能无法使用这些可以为您所带来更多乐趣的附加功能或在使用某些产品或服务时需要重复填写一些信息。这些附加功能包括：
      </p>
      <p>2)传送或散布以其他方式实现传送的含有受到知识产权法律保护的图像、相片、软件或其他资料的文件，作为举例（但不限于此）：包括版权或商标法（或隐私权或公开权），除非用户拥有或控制着相应的权利或已得到所有必要的认可；</p>

      <p>3)使用任何包含有通过侵犯商标、版权、专利、商业机密或任何一方的其他专有权利的方式利用本“软件”获得的图像或相片的资料或信息；</p>
      <p>
        4)进行危害计算机网络安全的行为，包括但不限于：使用未经许可的数据或进入未经许可的服务器/帐号；未经允许进入公众计算机网络或者他人计算机系统并删除、修改、增加存储信息；未经许可，企图探查、扫描、测试本平台系统或网络的弱点或其它实施破坏网络安全的行为；企图干涉、破坏本平台系统或网站的正常运行，故意传播恶意程序或病毒以及其他破坏干扰正常网络信息服务的行为；伪造TCP/IP数据包名称或部分名称；
      </p>
      <p>5)修改或伪造软件作品运行中的指令、数据、数据包，增加、删减、变动软件 的功能或运行效果，不得将用于上述用途的软件通过信息网络向公众传播或者运营；</p>
      <p>6）在未经徐房经纪人书面明确授权前提下，出售、出租、出借、散布、转移或转授权软件和服务或相关的链接或从使用软件和服务或软件和服务的条款中获利，无论以上使用是否为直接经济或金钱收益；</p>
      <p>7) 违背徐房经纪人页面公布之活动规则，包括但不限于发布虚假信息、作弊或通过其他手段进行虚假交易</p>

      <p>3、您了解并同意，徐房经纪人有权应政府部门（包括司法及行政部门）的要求，向其提供您在徐房经纪人平台填写的注册信息和发布纪录等必要信息。</p>
      <p>4、您了解并同意，为了向您提供有效的服务，徐房经纪人平台可能使用您的终端设备的带宽资源，使用过程中可能产生数据流量的费用，您需自行向运营商了解相关资费信息，并自行承担相关费用。</p>
      <p>5、在徐房经纪人平台上使用徐房经纪人平台服务过程中，您承诺遵守以下约定：</p>
      <p>
        1)在使用徐房经纪人平台服务过程中实施的所有行为均遵守国家法律、法规等规范文件及徐房经纪人平台各项规则的规定和要求，不违背社会公共利益或公共道德，不损害他人的合法权益，不违反本协议及相关规则。您如果违反前述承诺，产生任何法律后果的，您应以自己的名义独立承担所有的法律责任，并确保徐房经纪人免于因此产生任何损失或增加费用。
      </p>
      <p>2)不发布国家禁止发布的信息（除非取得合法且足够的许可），不发布涉嫌侵犯他人知识产权或其它合法权益的信息，不发布违背社会公共利益或公共道德、公序良俗的信息，不发布其它涉嫌违法或违反本协议及各类规则的信息。</p>

      <p>3)不对徐房经纪人平台上的任何数据作商业性利用，包括但不限于在未经徐房经纪人事先书面同意的情况下，以复制、传播等任何方式使用徐房经纪人平台站上展示的资料。</p>
      <p>4)不使用任何装置、软件或例行程序干预或试图干预徐房经纪人平台的正常运作或正在徐房经纪人平台上进行的任何活动。您不得采取任何将导致不合理的庞大数据负载加诸徐房经纪人平台网络设备的行动。</p>
      <p>6、您了解并同意：</p>
      <p>1)您违反上述承诺时，徐房经纪人有权依据本协议的约定，做出相应处理或终止向您提供服务，且无须征得您的同意或提前通知于您。</p>
      <p>2)根据相关法令的指定或者徐房经纪人平台服务规则的判断，您的行为涉嫌违反法律法规的规定或违反本协议和/或规则的条款的，徐房经纪人有权采取相应措施，包括但不限于直接屏蔽、删除侵权信息、降低您的信用值或直接停止提供服务。</p>
      <p>
        3)对于您在徐房经纪人平台上实施的行为，包括您未在徐房经纪人平台上实施但已经对徐房经纪人平台及其用户产生影响的行为，徐房经纪人有权单方认定您行为的性质及是否构成对本协议和/或规则的违反，并据此采取相应的处理措施。您应自行保存与您行为有关的全部证据，并应对无法提供充要证据承担不利后果。
      </p>
      <p>4)对于您涉嫌违反承诺的行为对任意第三方造成损害的，您均应当以自己的名义独立承担所有的法律责任，并应确保徐房经纪人免于承担因此产生的损失或增加的费用。</p>
      <p>5)如您涉嫌违反有关法律或者本协议之规定，使徐房经纪人遭受任何损失，或受到任何第三方的索赔，或受到任何行政管理部门的处罚，您应当赔偿徐房经纪人因此造成的损失及（或）发生的费用，包括合理的律师费用。</p>
      <p>第五部分 数据保护条款</p>
      <p>
        1、徐房经纪人平台运营方是本网站上呈现的所有信息内容的所有权及知识产权权利人，前述信息内容包括但不限于程序代码、界面设计、版面框架、数据资料、账号、文字、图片、图形、图表、音频、视频等。同时，徐房经纪人平台运营方对徐房经纪人平台所有运营方及其关联方、合作方在服务的开发和运营等过程中产生的所有数据和信息等享有全部权利。以上权利归属除按照法律法规规定或协议约束应由相关权利方享有权利的内容除外。
      </p>
      <p>2、未经徐房经纪人运营方书面许可，您不得自行或授权、允许、协助任何第三人对本网站中信息内容进行如下行为：</p>
      <p>1)复制、读取、采用本网站的信息内容，用于包括但不限于宣传、增加阅读量、浏览量等商业用途；</p>
      <p>2)采用包括但不限于特殊标识、特殊代码等形式的识别方法，自行或协助第三人对本网站信息或内容产生流量、阅读量引导、转移、劫持等不利影响；</p>
      <p>3)对本网站及其系统进行地址扫描、网络端口扫描、操作系统探测等扫描及/或探测，或以包括通过机器人、蜘蛛等程序或设备监视、复制、传播、展示、镜像、上载、下载等方式擅自获取、使用本网站内的任何内容；</p>
      <p>4)采用自动化手段或明显异于常人的、远高于正常用户频率地发布评论、私信、文章或作出关注、点赞、抓取（访问、抓取）数据等的行为；</p>
      <p>
        5)对本网站及其软件运行过程中释放到任何终端内存中的数据、软件运行过程中客户端与服务器端的交互数据，以及软件运行所必需的系统数据，进行复制、修改、增加、删除、挂接运行或创作任何衍生作品（信息或内容），形式包括但不限于使用插件、外挂或非经徐房经纪人授权的第三方工具/服务接入软件和相关系统。
      </p>

      <p>6)其他非法获取本网站的信息内容的行为。</p>
      <p>3、经徐房经纪人运营方书面许可后，您对本网站服务的信息和内容的分享、转发等行为（您在使用本网站提供的服务时），还应符合以下规范：</p>
      <p>1)对抓取、统计、获得的相关搜索热词、分类、排名、搜索量、点击率、阅读量等相关数据，未经公司事先书面同意，不得将上述（徐房经纪人平台上的任何）数据（或内容）以任何方式公示、提供、泄露给任何第三人；</p>
      <p>2)不得对本网站的源网页进行任何形式的改动，包括但不限于本网站主页、各功能接口、广告系统链接等入口，也不得对奔入服务的源页面的展示进行任何形式的遮挡、插入、弹窗等妨碍；</p>
      <p>3)应当采取安全、有效、严密的措施，防止本网站的信息内容被第三方通过包括但不限于“蜘蛛”（spider）程序等任何形式进行非法获取；</p>
      <p>4)不得把本网站数据内容用于徐房经纪人运营方书面许可范围之外的目的，进行任何形式的销售和商业使用，或向第三方泄露、提供或允许第三方为任何方式的使用。</p>
      <p>第六部分 责任范围和责任限制</p>
      <p>
        1、徐房经纪人仅向您提供徐房经纪人平台信息服务，您了解徐房经纪人平台上的信息系用户自行发布，由于海量信息的存在，且徐房经纪人平台无法杜绝可能存在风险和瑕疵。您应谨慎判断确定相关信息的真实性、合法性和有效性，并注意保留相应的证据以利于维权。
      </p>
      <p>2、徐房经纪人平台与其他的在线使用的互联网网站一样，也会受到各种不良信息、网络安全和网络故障问题的困扰，包括但不限于：</p>
      <p>1)其他用户可能会发布诈骗或虚假信息，或者发表有谩骂、诅咒、诋毁、攻击内容的等让人反感、厌恶的内容的非法言论；</p>
      <p>2)其他用户可能会发布一些侵犯您或者其他第三方知识产权、肖像权、姓名权、名誉权、隐私权和/或其他合法权益的图片、照片、文字等资料；</p>

      <p>3)面临着诸如黑客攻击、计算机病毒困扰、系统崩溃、网络掉线、网速缓慢、程序漏洞等问题的困扰和威胁。</p>
      <p>
        3、您充分了解并同意：上述的各种不良信息、网络安全和网络故障问题，并不是徐房经纪人或者徐房经纪人平台所导致的问题，由此可能会造成您感到反感、恶心、呕吐等精神损害，或者给您造成其他的损失，概由您自行承担，徐房经纪人无须向您承担任何责任。
      </p>
      <p>4、您同意，在发现本网站任何内容不符合法律规定，或不符合本用户协议规定的，您有义务及时通知徐房经纪人。如果您发现您的个人信息被盗用、您的版权或者其他权利被侵害，请将此情况告知徐房经纪人并同时提供如下信息和材料：</p>
      <p>1)侵犯您权利的信息的网址，编号或其他可以找到该信息的细节；</p>
      <p>2)您所述的版权或者其他权利的合法拥有者的权利证明；</p>
      <p>3)您的个人信息及有效联系方式，包括真实姓名，身份证号、地址，电话号码和电子邮件等；</p>
      <p>4)您的身份证复印件、营业执照等其他相关资料。</p>
      <p>经审查得到证实的，我们将及时删除相关信息。我们仅接受邮寄、电子邮件或传真方式的书面侵权通知。情况紧急的，您可以通过客服电话先行告知，我们会视情况采取相应措施。</p>
      <p>5、您了解并同意，徐房经纪人不对因下述任一情况而导致您的任何损害赔偿承担责任，包括但不限于利润、商誉、使用、数据等方面的损失或其它无形损失的损害赔偿：</p>
      <p>1) 使用或未能使用徐房经纪人平台服务；</p>
      <p>2) 第三方未经批准地使用您的账户或更改您的数据；</p>
      <p>3) 通过徐房经纪人平台购买、获取任何服务、数据、信息等行为或替代行为或与其他任何第三方搭建线上/线下交易、服务法律关系之间的全部事宜产生的费用及损失；</p>
      <p>4) 您对徐房经纪人平台服务的误解；</p>
      <p>5) 因不可抗力或其他因非徐房经纪人的原因而引起的与徐房经纪人平台服务有关的其它损失。</p>
      <p>6、您在徐房经纪人上使用第三方提供的产品或服务时，除遵守本协议约定外，还应遵守第三方的用户协议及其他相关规则。徐房经纪人和第三方对可能出现的纠纷在法律规定和约定的范围内各自承担责任。</p>
      <p>
        7、您同意在使用徐房经纪人平台服务过程中显示徐房经纪人自行或由第三方服务商向您发送或提供的推广或宣传信息、资讯、动态等（统称为推广信息，包括商业与非商业信息），其方式和范围可不经向您特别通知而变更。除法律法规明确规定外，您应自行对依该推广信息进行的交易审慎评估理性接受，并对交易后果负责，对用户因依该推广信息进行的交易或前述第三方服务商提供的内容因而遭受的损失或损害，徐房经纪人不承担任何责任。
      </p>
      <p>
        8、徐房经纪人对下列不可抗力行为免责：信息网络正常的设备维护，信息网络连接故障，电脑、通讯或其他系统的故障，电力故障，罢工，劳动争议，暴乱，起义，骚乱，生产力或生产资料不足，火灾，洪水，风暴，爆炸，战争，政府行为，司法行政机关的命令或第三方的不作为而造成的不能服务或延迟服务。
      </p>
      <p>9、您应当严格遵守本协议及徐房经纪人规则等，因您违反协议或规则的行为给第三方或徐房经纪人造成损失的，您应当承担全部责任。</p>
      <p>10、徐房经纪人保留在中华人民共和国大陆地区施行之法律允许的范围内独立决定拒绝服务、关闭用户账户、审查、编辑、清除用户发布内容或取消订单的权利。</p>
      <p>第七部分 协议终止</p>
      <p>
        1、您同意，徐房经纪人基于平台服务的安全性，有权中止向您提供部分或全部徐房经纪人平台服务，暂时冻结您的账户，待安全问题解决后及时恢复，并对中止、冻结及恢复的事实及时通知。如果网站的安全问题是由于您的违法行为引起，徐房经纪人有权终止向您提供部分或全部徐房经纪人平台服务，永久冻结（注销）您的帐户，并有权向您对损失进行索赔。
      </p>
      <p>2、您同意，您与徐房经纪人的协议关系终止后，徐房经纪人仍享有下列权利：</p>
      <p>1) 按法律规定保存您在使用徐房经纪人服务期间的信息发布记录、交易记录及其他登陆使用操作记录等。</p>
      <p>2）您在使用徐房经纪人平台服务期间存在违法行为或违反本协议和/或规则的行为的，徐房经纪人仍可依据本协议向您主张权利、追究责任。</p>
      <p>3、您可以在我们的APP端“我的”—设置—注销账号申请注销账户。您注销账户后，我们将停止为您提供产品与/或服务，并依据您的要求，除法律法规另有规定外，我们将删除您的个人信息。</p>
      <p>您注销账户后，我们将停止为您提供产品与/或服务，并依据您的要求，除法律法规另有规定外，我们将删除您的个人信息。</p>
      <p>第八部分 徐房经纪人用户权益保护</p>
      <p>1、真房源服务承诺</p>
      <p>
        真房源指同时满足真实存在、真实图片、真实在租、真实价格四项标准。其中，真实存在指房源地址与产权地址或实际物理地址一致；真实图片指房源展示的图片是本房现状照片（不包括房源户型图）；真实在售指房源在售的状态是业主的真实意愿；真实价格指在徐房经纪人发布的房源价格以业主委托报价为基准。
      </p>
      <p>2、徐房经纪人用户个人信息保护</p>
      <p>1)徐房经纪人将在平台公布并不时修订隐私权条款，隐私权条款构成本协议的有效组成部分</p>
      <p>2)您知悉并认可：在对您信息进行脱敏处理后，徐房经纪人有权对整个用户数据库进行分析并对用户数据库进行商业上的利用。</p>
      <p>3)徐房经纪人将运用各种安全技术和程序建立完善的管理制度来保护您的个人信息，以免遭受未经授权的访问、使用或披露。</p>
      <p>4)徐房经纪人不会将您的个人信息转移或披露给任何非关联的第三方，除非：相关法律法规或法院、政府机关要求；为完成合并、分立、收购或资产转让而转移；为提供您要求的服务所必需；为您提供任何您可能感兴趣的信息或服务。</p>
      <p>
        5)徐房经纪人通过推广或其他方式向您提供链接，使您可以接入第三方服务或网站。您使用该等第三方的服务时，须受该第三方的服务条款及隐私政策约束，您需要仔细阅读其条款。本协议仅适用于徐房经纪人提供的服务器所收集的信息，并不适用于任何第三方提供的服务或第三方的信息使用规则，徐房经纪人对任何第三方使用由您提供的信息不承担任何责任。
      </p>
      <p>6)当您终止使用徐房经纪人的服务注销徐房经纪人账号的，徐房经纪人将停止收集并使用您的个人信息。</p>
      <p>7)关于用户个人信息的收集、存储、使用等事宜，具体可详见《徐房经纪人隐私政策》。</p>
      <p>为提升用户服务体验，随着国家法律法规的调整及徐房经纪人业务的发展，各服务承诺和计划会随之进行更新，具体执行的权益细则以页面详情页显示为准。</p>
      <p>3、侵权信息处理及投诉渠道</p>

      <p>	1)侵权信息处理</p>
      <p>如用户发现个人信息被盗用、版权或者其他权利被侵害，请将此情况告知徐房经纪人并同时提供如下信息和材料：侵犯用户权利的信息的网址，编号或其他可以找到该信息的细节；用户是所述的版权或者其他权利的合法拥有者的权利证明；用户的个人信息及有效联系方式，包括真实姓名，身份证号、地址，电话号码和电子邮件等；用户的身份证复印件、营业执照等其他相关资料。经审查得到证实的，我们将及时删除相关信息。我们仅接受邮寄的书面侵权通知。情况紧急的，您可以通过客服电话先行告知，我们会视情况采取相应措施。</p>
      <p>	2)联系及投诉渠道</p>
      <p>为维护用户和相关权利人利益，徐房经纪人平台以公示的方式，为用户及相关权利人提供丰富、便捷的线上线下投诉渠道。用户可以通过拨打客服电话0516-83601286或通过徐房经纪人网站在线客服的方式提交问题反馈。</p>
      <p>第十部分 法律适用、管辖与其他</p>
      <p>1、本协议之订立、生效、解释、修订、补充、终止、执行与争议解决均适用中华人民共和国法律，如法律无相关规定的，则应参照通用国际商业惯例和（或）行业惯例。</p>
      <p>2、本协议任一条款被视为废止、无效或不可执行，该条应视为可分的且并不影响本协议其余条款的有效性及可执行性。</p>
      <p>3、因本协议产生之争议、纠纷，应由徐房经纪人与您友好协商解决；协商不成的，任何一方均有权向徐房经纪人所在区域的人民法院诉讼解决。</p>
      <p>为给您提供更好的服务以及随着国家法律法规的调整、徐房经纪人业务的发展，本协议也会随之更新。但未经您明确同意，我们不会削减您依据本隐私政策所应享有的权利。我们会通过在徐房经纪人网站、徐房经纪人移动端上发出更新版本并在生效前通过适当方式提醒您相关内容的更新，也请您访问徐房经纪人以便及时了解最新的隐私政策 。</p>
      <p>当您注册或登录时，点击“用户协议和隐私政策”弹框里的“同意”按钮即视为您完全接受本协议，在点击之前请您再次确认已知悉并完全理解本协议的全部内容。</p>
    </div>
  </div>
</template>

<script>
import topHeader from '@/components/header';
export default {
  data() {
    return {
    }
  },
  components: {
    topHeader,
  },
}
</script>
<style lang="less" scoped>
.fixed {
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  z-index: 9;

  .top_normal {
    height: 100%;

    i {
      font-size: 0.32rem;
    }
  }
}

.top_header {
  height: 0.7rem;
  padding: 0.2rem 0rem;
  margin: 0 auto;
  font-size: 0.32rem;
  background-color: #fff;
  border-bottom: 1px solid #f5f5f5;
}

.pad_top {
  padding-top: 1.1rem;
}

h3 {
  font-size: 0.3rem;
  font-weight: 800;
  text-align: center;
  padding: 0.3rem 0rem;
}

.con {
  padding: 0 0.3rem 0.6rem;

  .top_ {
    font-size: 0.24rem;
    color: #999;

    p {
      line-height: 0.5rem;
      text-indent: 0;
    }
  }

  h4 {
    font-size: 0.28rem;
    font-weight: 800;
    padding: 0.3rem;
    text-align: center;
  }

  p {
    font-size: 0.26rem;
    line-height: 0.5rem;
    color: #666;
    text-indent: 0.52rem;
  }
}</style>
